import styled from "styled-components";

interface Props {
    open: boolean;
}

const Container = styled.div`
    transition: opacity .2s ease-in-out;
    
    .blur {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        backdrop-filter: blur(2px);
        z-index: 100;
        pointer-events: all;
    }
    
    .loader-circle {
        z-index: 101;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        box-shadow: inset 0 0 0 1px rgba(255,255,255,.1);
        margin-left: -60px;
        margin-top: -60px;
    }

    .loader-line-mask {
        z-index: 101;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 60px;
        height: 120px;
        margin-left: -60px;
        margin-top: -60px;
        overflow: hidden;
        transform-origin: 60px 60px;
        -webkit-mask-image: -webkit-linear-gradient(top, rgba(0,0,0,1), rgba(0,0,0,0));
        animation: rotate 1.2s infinite linear;
        .loader-line {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            box-shadow: inset 0 0 0 1px rgba(255,255,255,.5);
        }
    }
    
    @keyframes rotate { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);}}
    
`;

export default function Loading({open}: Props) {
    return (
        <Container style={{opacity: open ? 1 : 0, pointerEvents: open ? 'all' : 'none' }}>
            {open && (<div className={'blur'}></div>)}
            <div className="loader-circle"></div>
            <div className="loader-line-mask">
                <div className="loader-line"></div>
            </div>
        </Container>
    );
}
